import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Sunrise, Sun, Sunset, Moon, Star, Compass } from "lucide-react";

const ICONS = {
  fajr: Star, sunrise: Sunrise, dhuhr: Sun, asr: Compass, maghrib: Sunset, isha: Moon,
};

function fmt(t) {
  if (!t) return "—";
  // 24h -> 12h
  const [h, m] = t.split(":").map(Number);
  if (isNaN(h)) return t;
  const ampm = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m || 0).padStart(2, "0")} ${ampm}`;
}

export default function PrayerTimes({ times }) {
  const { t, lang } = useLang();
  const rows = ["fajr", "sunrise", "dhuhr", "asr", "maghrib", "isha"];
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";

  return (
    <section id="prayer" data-testid="prayer-section" className="bg-stone-50 py-20 md:py-28 relative">
      <div className="absolute inset-0 pattern-overlay opacity-60 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="flex flex-col items-center text-center mb-12">
          <span className="text-xs uppercase tracking-[0.3em] text-amber-700 mb-3">صلاة · Salah</span>
          <h2 data-testid="prayer-heading" className={`${fontH} text-4xl md:text-5xl text-emerald-950`}>{t("prayer_heading")}</h2>
          <p className={`mt-3 text-stone-500 ${lang === "ta" ? "font-sans-ta" : ""}`}>{t("prayer_subhead")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {rows.map((k) => {
            const Icon = ICONS[k];
            return (
              <div key={k} data-testid={`prayer-${k}`} className="mosque-card p-5 flex flex-col items-center text-center">
                <Icon className="w-6 h-6 text-amber-700 mb-3" />
                <div className={`${fontH} text-xl text-emerald-950`}>{t(k)}</div>
                <div className="mt-2 text-2xl font-light tracking-tight text-stone-800">{fmt(times?.[k])}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 mosque-card p-6 flex flex-col md:flex-row items-center justify-between gap-3 border-emerald-900/20 bg-emerald-50/50">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-emerald-900 grid place-items-center text-amber-300 font-serif-en">ج</div>
            <div>
              <div className={`${fontH} text-xl text-emerald-950`}>{t("jumuah")}</div>
              <div className="text-xs text-stone-500 uppercase tracking-widest">Friday Congregation</div>
            </div>
          </div>
          <div data-testid="prayer-jumuah" className="text-3xl font-light text-emerald-900">{fmt(times?.jumuah)}</div>
        </div>
      </div>
    </section>
  );
}
